import Menu from '../components/Menu/Menu.js'
import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { doLogOut } from '../actions/keycloak.js'

const MenuContainer = props => (
  <Menu
    showNewShipment={props.showNewShipment}
    doLogOut={props.doLogOut}
    user={props.user}
    sessions={props.sessions}
    proposals={props.proposals}
    breadcrumbsList={props.breadcrumbsList}
    application={props.application}
    jobs={props.jobs}
    configuration={props.configuration}
    keycloak={props.keycloak}
  />
)

function mapStateToProps(state) {
  return {
    user: state.user,
    sessions: state.sessions,
    proposals: state.proposals,
    breadcrumbsList: state.breadcrumbsList,
    application: state.application,
    jobs: state.jobs,
    configuration: state.configuration,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    doLogOut: bindActionCreators(doLogOut, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MenuContainer)
